import React from 'react';
import { DATE_TIME_FORMAT } from 'src/constants/CommonConstants';
import { UnAuthorizedErrorPage } from 'src/utils/CommonUtils';
import SearchContainerWithPermission from '../search-container/SearchContainerWithPermission';

const CustomerSearch = (props) => {
    const {
        customerEditAction,
        redirectUrlOnEdit,
        customerSearchAction,
    } = props;

    return (
        <SearchContainerWithPermission
            scope="master.customer_manager.search"
            editScope="master.customer_manager.search.edit"
            fallback={<UnAuthorizedErrorPage />}
            reducer="CustomerReducer"
            dataPath="search"
            editAction={customerEditAction}
            redirectUrlOnEdit={redirectUrlOnEdit}
            action={customerSearchAction}
            hasEdit
            columns={{
                firstName: {
                    display: 'First Name',
                },
                lastName: {
                    display: 'Last Name',
                },
                houseOwnershipResidence: {
                    display: 'Address',
                },
                phone: {
                    display: 'Phone',
                },
                email: {
                    display: 'Email',
                },
                company: {
                    display: 'Company',
                },
                designation: {
                    display: 'Designation',
                },
                active: {
                    display: 'Active',
                },
                by: {
                    display: 'By',
                    path: 'by.personalInfo.firstName',
                },
                updatedBy: {
                    display: 'Updated By',
                    path: 'updatedBy.personalInfo.firstName',
                },
                ts: {
                    display: 'Ts',
                    type: Date,
                    format: DATE_TIME_FORMAT.TIMEAGO,
                },
                updatedTs: {
                    display: 'Updated Ts',
                    type: Date,
                    format: DATE_TIME_FORMAT.TIMEAGO,
                },
            }}
        />
    );
};

export default CustomerSearch;
